var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"text-center",attrs:{"bg-variant":"light","text-variant":"dark"}},[_c('b-card-body',[_c('MapChart',{attrs:{"countryData":{ US: 4, CA: 7, GB: 8, IE: 14, ES: 21 },"highColor":"#ff0000","lowColor":"#aaaaaa","countryStrokeColor":"#909090","defaultCountryFillColor":"#dadada","LangUser":"fr"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }